import { Component, OnInit, ViewChild, OnDestroy, Inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Subject } from 'rxjs';
import { HttpService } from 'src/app/services/http/http.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import { IPageData } from 'src/app/interfaces/page-data';
import { BasePageComponent } from '../../base-page';
import { Spinkit } from 'ng-http-loader';
import * as PageActions from '../../../store/actions/page.actions';
import {Location} from '@angular/common';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.scss']
})
export class UserprofileComponent extends BasePageComponent implements OnInit, OnDestroy {
  pageData: IPageData;
  value: number = 0;
  public spinkit = Spinkit;
  restoID
  ids
  UserCondition
  user_details
  token
  tableids 
  taste_id
  taste_code
  taste_totalScore
  expiry
  id
  female = './assets/img/female.png'
  male = './assets/img/male.png'
  userName 
  encodeid 
  encodeexpiry
  tokenCheck 
  defalutimage ='./assets/img/PngItem_1503945.png'
  decodetoken
  encodedJwtJsonData
  userName_loggedin
  userdatails_array =[]
  public totalSubject = new Subject()
  public orderSubject = new Subject()
  lengthallergens:any;
  lengthdietary: any;
  user_Name: any;
  errorMessage: any;
  crossC:any;
  messageFilesize: string;
  currentAvatar: string | ArrayBuffer;
  imageFile: FormData;
  constructor(store: Store<IAppState>,
    public httpSv: HttpService,private router:Router,
    private route: ActivatedRoute,private _bottomSheet: MatBottomSheet,
    private _location: Location) { 
    super(store, httpSv);
    this.pageData = {
      title: '',
      loaded: true,
      breadcrumbs: [
        {
          title: '',
          route:'userprofile'
        }
      ]
    };
  }
  ngOnInit() {
    this.restoID=sessionStorage.getItem("restoId")
    this.token=sessionStorage.getItem('access_token')
    this.ids=sessionStorage.getItem('restoIds')

    this.tableids =sessionStorage.getItem('tableIds')
    this.route.queryParams.subscribe(params => {
    this.UserCondition = sessionStorage.getItem('access_token') ? true : false;
    });
    this.pageData ? this.store.dispatch(new PageActions.Set(this.pageData)) : null;
    if (this.UserCondition) {
      this.userProfile();
      this.tasteDetailsget();
      this.userName_loggedin = sessionStorage.getItem('userName')
      this.user_Name = this.userName_loggedin.split(" ");
      this.userName = this.user_Name[0]
    }
    this.encodedJwtJsonData = btoa(this.token)
  }

  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }
  backTologin(){
    this.router.navigate(['/public/sign-in']);  
    sessionStorage.setItem("guestTouserProfile","true")
  }
  backHomeUser(){
		this.router.navigate(['/horizontal/resto'])
  }
  backHomeGuest(){
		this.router.navigate(['/public/resto'])
  }
  logout() {
		this.httpSv.logouts(this.token).subscribe(
			response => {
					this.router.navigate(['public/resto'], {
						queryParams: {
							id: this.ids,
							table_id: this.tableids
						}
          });
          sessionStorage.clear();
			}
		)
	}
 
  OnEditclick(){
    this.router.navigate(['/horizontal/edit-tasteprofile'])
  }
 
  backClicked() {
    this._location.back();
  }
  userProfile(){ 
    this.httpSv.userProfile().subscribe(response =>{
    if(response['status'] == true){
    this.user_details = response['result']
    this.userdatails_array.push(this.user_details); 
    if(this.user_details.userAllergens){
      this.lengthallergens =(this.user_details.userAllergens.length)
    }
    if(this.user_details.userDietary){
      this.lengthdietary =(this.user_details.userDietary.length)
    }
     }
    }, (err: HttpErrorResponse) => {
      this.logout();
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
    })
  }

  myDetails(){
    sessionStorage.setItem('Details','true')
    sessionStorage.removeItem('preferences')
    sessionStorage.removeItem('myfriend')
    sessionStorage.removeItem('sharefriends')
  }
  mypreferences(){
    sessionStorage.setItem('preferences','true')
    sessionStorage.removeItem('Details')
    sessionStorage.removeItem('myfriend')
    sessionStorage.removeItem('sharefriends')
  }

  myfriend(){
    sessionStorage.setItem('myfriend','true')
    sessionStorage.removeItem('Details')
    sessionStorage.removeItem('preferences')
    sessionStorage.removeItem('sharefriends')
  }
  sharefriends(){
    sessionStorage.setItem('sharefriends','true')
    sessionStorage.removeItem('Details')
    sessionStorage.removeItem('preferences')
    sessionStorage.removeItem('myfriend')
  }

  count(j){
    let spicevar=[]
    for(let i=0;i<j;i++){
      spicevar.push(j)
    }  
    return spicevar
  }
  tasteDetailsget(){
 this.httpSv.tasteDetailsget().subscribe(res=>{
   if(res['status'] == true){
     this.taste_id = res['result'].data.tc_id
     this.taste_code = res['result'].data.tc_code
     this.taste_totalScore = res['result'].data.totalScore
   }
 }, (err: HttpErrorResponse) => {
  if (err.status == 401) {
    this.logout();
  }
  else if (err.status == 500) {
    this.logout();
  }
})
  }

  tasteidgenerate(){
    window.open(environment.quizlinkUrl + '?id=' +this.encodedJwtJsonData )
  }
  onsharefriends(){
    this.router.navigate(['/horizontal/edit-tasteprofile'])
    sessionStorage.setItem('sharefriend','true')
  }
  onClickallergen() {
    this._bottomSheet.open(BottomSheetOverviewprofileallergens , {
      
    });
  };

  onClickdietary(){
    this._bottomSheet.open(BottomSheetOverviewprofiledietary, { 
    });
  };

  fileChange(event) {
    let fileList: FileList = event.target.files;
  }

  onImageChange(event) {
    if (event.target.files && event.target.files[0]) {
      const fsize = event.target.files[0].size;
      const fileSize = Math.round((fsize / 1024));
      if (fileSize < 2048) {
        this.imageFile = new FormData();
        this.imageFile.append('file', event.target.files[0]);
        let file: File = event.target.files[0];
        let reader: FileReader = new FileReader();
        this.messageFilesize = ""
        reader.onloadend = () => {
          this.currentAvatar = reader.result;
        };
        reader.readAsDataURL(file);
        this.uploadImage();
      }
      else {
        this.messageFilesize = "File too Big, please select a file less than 2mb"
      }
      
    }

  }

	crossCon(value) {
		if (value == true) {
			this.crossC = "Yes"
		} else
			this.crossC = "No"
		const data = {
			status: this.crossC
		}
		sessionStorage.setItem('UserCC', this.crossC)
		this.httpSv.updateUserPreference(data).subscribe(
			response => {
				if (response['status'] == true) {
				} else {
					Swal.fire("Something Went Wrong")
				}
			}
		)
	}

  uploadImage() {
    this.httpSv.updateuserImage(this.imageFile).subscribe(
      response => {
        if (response['status'] == true) {
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['horizontal/userprofile']);    
          })
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401) {
          this.logout();
          Swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
        else if (err.status == 500) {
          this.logout();
          Swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
      }
    )
  }
}

@Component({
  selector: 'bottom-sheet-overview-profile-allergens',
  templateUrl: 'bottom-sheet-overview-profile-allergens.html',
})
export class BottomSheetOverviewprofileallergens implements OnInit{
  user_details: any;
  userdatails_array =[];
  ids: any;
  token;
  allgens_id 
  Ingredient_id
  tableids: any;
  constructor( @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewprofileallergens>,private router: Router,public httpSv: HttpService) {
  }
ngOnInit(){
this.userProfile();
}


  logout() {
		this.httpSv.logouts(this.token).subscribe(
			response => {
				if (response['status'] == true) {
					sessionStorage.clear();
					this.router.navigate(['public/resto'], {
						queryParams: {
							id: this.ids,
							table_id: this.tableids
						}
					});
				} else {
					Swal.fire("Something Went Wrong")
				}
			}
		)
	}

  userProfile(){ 
    this.httpSv.userProfile().subscribe(response =>{
    if(response['status'] == true){
    this.user_details = response['result']
    this.userdatails_array.push(this.user_details); 
     }
    }, (err: HttpErrorResponse) => {
      this.logout();

      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
    })
  }
}

@Component({
  selector: 'bottom-sheet-overview-profile-dietary',
  templateUrl: 'bottom-sheet-overview-profile-dietary.html',
})
export class BottomSheetOverviewprofiledietary implements OnInit{
  user_details: any;
  userdatails_array =[];
  ids: any;
  token;
  userdislike_id
  tableids: any;
  dietary_id 
  constructor( @Inject(MAT_BOTTOM_SHEET_DATA) public data: any, private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewprofiledietary>,private router: Router,public httpSv: HttpService) {
  }

  ngOnInit(){
    this.token=sessionStorage.getItem('access_token')
    this.userProfile();
  }

  logout() {
		this.httpSv.logouts(this.token).subscribe(
			response => {
				if (response['status'] == true) {
					sessionStorage.clear();
					this.router.navigate(['public/resto'], {
						queryParams: {
							id: this.ids,
							table_id: this.tableids
						}
					});
				} else {
					Swal.fire("Something Went Wrong")
				}
			}
		)
	}

  userProfile(){ 
    this.httpSv.userProfile().subscribe(response =>{
    if(response['status'] == true){
    this.user_details = response['result']
    this.userdatails_array.push(this.user_details); 
     }
    }, (err: HttpErrorResponse) => {
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
    })
  }
}

